export const PERSONAS_QUERY_KEY = ['personas'];
